<template>
  <div class="container mx-auto py-10 px-4">
    <div class="bg-white rounded-lg p-6 text-center">
      <div class="flex justify-center">
        <CheckCircleIcon class="text-primary-500 w-20 h-20" size=82 />
      </div>
    <h3 class="text-2xl font-semibold text-gray-800 mb-2" v-html="title"></h3>
    <p class="text-gray-600 mb-4" v-html="subtitle"></p>
    <button @click="goToLink"
      class="primary-button w-72 inline-flex justify-center whitespace-nowrap  px-3.5 py-2.5 text-sm font-medium text-white shadow-sm focus:outline-none transition-colors duration-150">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import CheckCircleIcon from 'vue-material-design-icons/CheckCircle.vue';
import Globals from '@shared/model/Globals.js';

export default defineComponent({
  name: 'Success',
  props: {
    title: {
      type: String,
      default: 'Twoje zgłoszenie zostało wysłane'
    },
    subtitle: {
      type: String,
      default: 'Dziękujemy za dokonanie zgłoszenia.'
    },
    buttonText: {
      type: String,
      default: 'Powrót do strony głównej'
    },
    link: {
      type: String,
      default: null
    }
  },
  components: {
    CheckCircleIcon
  },
  methods: {
    goToLink() {
      const link = this.link;

      if (link) {
        window.location.href = link;
        return;
      }

      const referer = localStorage.getItem('referer');
      if (referer) {
        window.location.href = referer;
      } else {
        window.location.href = Globals.APP_HOME_URL;
      }
    }
  }
});
</script>